module.exports = __webpack_public_path__ + "img/article_4_1.9ddd779c.png";